import './Checkbox.less';
import type { ChangeEvent, PropsWithChildren } from 'preact/compat';

export type CheckboxProps = PropsWithChildren<{
    className?: string;
    onChange?: (event: ChangeEvent, state: boolean) => void;
    checked: boolean;
    size?: 'medium' | 'large';
}>;

const Checkbox = ({
    className = '',
    children = '',
    onChange,
    checked,
    size = 'medium'
}: CheckboxProps) => {
    return (
        <label
            className={`bri-Checkbox bri-Checkbox-size-${size} bri-Body2Font ${className}`}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={event => onChange?.(event, !checked)}
            />
            {typeof children === 'string' && children !== '' && (
                <span>{children}</span>
            )}
            {typeof children !== 'string' && children}
        </label>
    );
};

export default Checkbox;
